import React, { useEffect, useCallback, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from './../../../store/actions';
import CloseIcon from '@mui/icons-material/Close';
import EventModalHeader from './EventModalHeader/EventModalHeader';
import { isEmpty } from 'lodash';
import EventModalCard from './EventModalCard/EventModalCard';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import LoadingCard from './EventModalCard/LoadingCard';
import { i18n } from '../../../translate/i18n';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

const EventModal = props => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const limit = 20;
  const [page, setPage] = useState(1);
  const modalOpen = useSelector(state => state.calendars.modalOpen)
  const modalData = useSelector(state => state.calendars.modalData)
  const modalType = useSelector(state => state.calendars.modalType);
  const modalDate = useSelector(state => state.calendars.modalDate);
  const modalStage = useSelector(state => state.calendars.modalStage);
  const modalLoading = useSelector(state => state.calendars.loadingModal);
  const loadingMoreModal = useSelector(state => state.calendars.loadingMoreModal);
  const totalEventsCount = useSelector(state => state.calendars.totalEventsCount);
  const filteredUsers = useSelector(state => state.calendars.filteredUsers);
  const filteredUsersMaintenances = useSelector(state => state.calendars.filteredUsersMaintenances);
  const filteredEquipmentModels = useSelector(state => state.calendars.filteredEquipmentModels);
  const filteredEquipmentGroups = useSelector(state => state.calendars.filteredEquipmentGroups);
  const filteredServiceTypes = useSelector(state => state.calendars.filteredServiceTypes);
  const filteredFrequencies = useSelector(state => state.calendars.filteredFrequencies);
  const filteredPlaces = useSelector(state => state.calendars.filteredPlaces);
  const filteredModules = useSelector(state => state.calendars.filteredModules);
  const filteredAreas = useSelector(state => state.calendars.filteredAreas);
  const filteredStatus = useSelector(state => state.calendars.filteredStatus);
  const filteredStatusMaintenances = useSelector(state => state.calendars.filteredStatusMaintenances);
  const filteredCompanies = useSelector(state => state.calendars.filteredCompanies);
  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);

  const fetchCompletedActionsByDay = useCallback((date, isNew) => dispatch(actions.fetchCompletedActionsByDay(page, limit, date, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies, filteredStatus, filteredStatusMaintenances, isNew)));

  const fetchInProgressActionsByDay = useCallback((date, isNew) => dispatch(actions.fetchInProgressActionsByDay(page, limit, date, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies, filteredStatus, filteredStatusMaintenances, isNew)));

  const fetchCompletedServicesByDay = useCallback((date, isNew) => dispatch(actions.fetchCompletedServicesByDay(page, limit, date, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies, filteredStatus, filteredStatusMaintenances, isNew)));

  const fetchInProgressServicesByDay = useCallback((date, isNew) => dispatch(actions.fetchInProgressServicesByDay(page, limit, date, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies, filteredStatus, filteredStatusMaintenances, isNew)));

  const fetchMaintenancesByDay = useCallback((date, isNew) => dispatch(actions.fetchMaintenancesByDay(page, limit, date, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies, filteredStatus, filteredStatusMaintenances, isNew)));


  const isAction = modalType === 'action';
  const isService = modalType === 'service';
  const isMaintenance = modalType === 'maintenance';
  const isDone = modalStage === 'done';
  const isScheduled = modalStage === 'scheduled';
  const isOverdue = modalStage === 'overdue';

  useEffect(() => {
    const isNew = page === 1;
    if (isAction && isDone) fetchCompletedActionsByDay(modalDate, isNew);
    if (isAction && (isScheduled || isOverdue)) fetchInProgressActionsByDay(modalDate, isNew);
    if (isService && isDone) fetchCompletedServicesByDay(modalDate, isNew);
    if (isService && (isScheduled || isOverdue)) fetchInProgressServicesByDay(modalDate, isNew);
    if (isMaintenance) fetchMaintenancesByDay(modalDate, isNew);

  }, [modalType, modalDate, page]);


  const closeModal = () => {
    dispatch(actions.modalCalendarsClose());
    setPage(1);
  }

  return (
    <Drawer
      anchor='right'
      open={modalOpen}
      onClose={closeModal}
      classes={{
        paper: classes.paper
      }}
    >
      <div style={styles.modalContainer}>
        <div style={styles.closeIconContainer}>
          <CloseIcon style={styles.closeIcon} onClick={closeModal}/>
        </div>
        {<EventModalHeader />}
        {!isEmpty(modalData) && <EventModalCard page={page}/>}
        {modalLoading && <LoadingCard stage={modalStage} />}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {(totalEventsCount > modalData.length) && <LoadingButton onClick={() => setPage(page => page + 1)} variant='outlined' loading={loadingMoreModal} sx={{ mb: 2 }}>
            { i18n.t('scheduledServicesEventCardList.showMoreButton')}
          </LoadingButton>}
        </Box>
      </div>
    </Drawer>
  );
}

const useStyles = makeStyles({
  paper: {
    backgroundColor: '#F5F5F5',
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
});

const styles = {
  modalContainer: {
    width: 400,
    backgroundColor: '#F5F5F5',
    position: 'relative',
    height: '100%',
    paddingTop: 50,
    paddingLeft: 30,
    paddingRight: 20,
    paddingBottom: 50,
  },
  closeIconContainer: {
    position: 'absolute',
    top: 10,
    left: 15,
  },
  closeIcon: {
   fontSize: 30,
   cursor: 'pointer'
  }
}


export default EventModal;

